/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import React, { Component } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

import "app/static/stylus/visualizationConsole.styl"

class VisualizationConsole extends Component {
    static propTypes = {
        activeVisualization: PropTypes.func.isRequired,
        // the active scene ID is returned from the selectors -- if there is
        // no active ID in the store, it will default to the defaultActiveSceneId
        // specified in the console instantiation. This will *always*
        // be defined as a result, even if there's nothing in the store.
        activeVisualizationId: PropTypes.string.isRequired,
        setActiveVisualization: PropTypes.func.isRequired,
        permissionedButtonGroups: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string.isRequired,
                icon: PropTypes.string.isRequired,
                dropdownScenes: PropTypes.array.isRequired,
            }),
        ),
        shouldShowVisualizationConsoleBar: PropTypes.bool.isRequired,
        uniqueFlvId: PropTypes.string.isRequired,
        defaultActiveSceneId: PropTypes.string,
    }

    setActiveScene = (activeId) => {
        if (this.props.activeVisualizationId !== activeId) {
            this.props.setActiveVisualization(this.props.uniqueFlvId, activeId)
        }
    }

    renderDropdown(group, hasActiveButton) {
        return (
            <button key={group.label} className={classNames("btn", "dropdown", { active: hasActiveButton })}>
                <div
                    className="dropdown-toggle"
                    data-bs-toggle="dropdown"
                    role="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                    <i className={`fa ${group.icon}`} />
                    {group.label}
                    <i className="fa fa-angle-down" />
                </div>
                <div className="dropdown-menu">
                    {group.dropdownScenes.map((scene) => {
                        const sceneId = scene.defaultProps.uniqueVizSceneId
                        const setScene = () => this.setActiveScene(sceneId)
                        return (
                            <div
                                key={scene.defaultProps.label}
                                onClick={setScene}
                                className={classNames({
                                    "dropdown-item": true,
                                    active: sceneId === this.props.activeVisualizationId,
                                })}
                            >
                                <i className={`fa ${scene.defaultProps.icon}`} />
                                {scene.defaultProps.label}
                            </div>
                        )
                    })}
                </div>
            </button>
        )
    }

    renderButtons() {
        return this.props.permissionedButtonGroups
            .filter((group) => group && group.dropdownScenes.length)
            .map((group) => {
                const hasActiveButton = group.dropdownScenes.find(
                    (scene) => scene.defaultProps.uniqueVizSceneId === this.props.activeVisualizationId,
                )
                return this.renderDropdown(group, hasActiveButton)
            })
    }

    render() {
        const ActiveVisualization = this.props.activeVisualization
        return (
            <div className="visualization-console" data-cy="visualization-console">
                {this.props.shouldShowVisualizationConsoleBar && (
                    <div className="visualization-console-buttons">{this.renderButtons()}</div>
                )}
                <div
                    className={classNames("visualization-in-console", {
                        "has-console-buttons": this.props.shouldShowVisualizationConsoleBar,
                    })}
                >
                    <ActiveVisualization {...this.props} />
                </div>
            </div>
        )
    }
}

export default VisualizationConsole
